<div class="wrapper flex column">
  <app-header title="{{ 'USER_PROFILE.HEADER.TITLE' | translate }}"></app-header>
  @if (!loading()) {
    <div class="content flex column grow1">
      <div
        class="auto-save-box flex vcenter"
        [class.show]="saving"
      >
        <img
          alt=""
          src="assets/shared/global-images/icons/dot-green.svg"
        />
        <span>{{ "AUTOSAVE" | translate }}</span>
      </div>
      <div class="user-management-box flex">
        <button
          mat-button
          class="avatar flex hcenter vcenter"
        >
          {{ userInitials }}
        </button>
        <form
          class="user-form flex column grow1"
          [formGroup]="userForm"
        >
          <payee-form-field>
            <div payee-label>
              {{ "USER_PROFILE.LAST_NAME_LABEL" | translate }}
            </div>
            <input
              payee-input
              formControlName="lastName"
            />
            @if (lastName.hasError("required") && lastName.dirty) {
              <mat-error payee-error>
                {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
              </mat-error>
            }
          </payee-form-field>
          <payee-form-field>
            <div payee-label>
              {{ "USER_PROFILE.FIRST_NAME_LABEL" | translate }}
            </div>
            <input
              payee-input
              formControlName="firstName"
            />
            @if (firstName.hasError("required") && firstName.dirty) {
              <mat-error payee-error>
                {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
              </mat-error>
            }
          </payee-form-field>
          <payee-form-field>
            <div
              payee-label
              class="payee-label-top"
            >
              {{ "USER_PROFILE.EMAIL_LABEL" | translate }}
            </div>
            <input
              readonly
              payee-input
              formControlName="email"
            />
          </payee-form-field>
        </form>
        <div class="user-management-buttons-box flex column">
          <button
            payee-button
            class="security-button"
            color="white"
            width="max"
            height="tall"
            [isBorderButton]="true"
            [disabled]="!canChangePassword"
            (click)="changePassword()"
          >
            <payee-icon name="lock-blue"></payee-icon>
            <span>{{ "USER_PROFILE.PASSWORD_RESET" | translate }}</span>
          </button>
          <button
            payee-button
            class="security-button"
            color="white"
            width="max"
            height="tall"
            [isBorderButton]="true"
            (click)="manageMFA()"
          >
            <payee-icon name="lock-blue"></payee-icon>
            <span>{{ (has2FA ? "USER_PROFILE.DISABLE_2FA" : "USER_PROFILE.ENABLE_2FA") | translate }}</span>
          </button>
        </div>
      </div>
      <div class="clients-title">
        {{ "USER_PROFILE.CLIENTS_LIST.TITLE" | translate }}
      </div>
      <div class="clients-list">
        @for (client of clients; track client.id; let i = $index) {
          @if (i > 0) {
            <payee-horizontal-line></payee-horizontal-line>
          }
          <a
            mat-button
            class="client-name"
            routerLink="/user/cases"
            [queryParams]="{ client_id: client.id }"
            [attr.aria-label]="
              (client.name || ('SIDEBAR.CLIENT_PH' | translate)) + ', ' + ('USER_PROFILE.CLIENTS_LIST.SHOW_CASES' | translate)
            "
          >
            {{ client.name || "SIDEBAR.CLIENT_PH" | translate }}
          </a>
          <div class="client-actions flex vcenter">
            <button
              mat-button
              class="client-settings"
              (click)="navigateToClientProfile(client)"
            >
              <div class="client-settings-content flex vcenter hcenter">
                <span>{{ "USER_PROFILE.CLIENTS_LIST.EDIT" | translate }}</span>
                <img
                  alt=""
                  src="assets/shared/global-images/icons/gear.svg"
                />
              </div>
            </button>
            <button
              mat-button
              class="delete-client-button"
              color="grey-light"
              [disabled]="clients.length <= 1"
              [matTooltip]="clients.length <= 1 ? ('CLIENT_ACCESS.DELETE.TOOLTIP_LAST' | translate) : ''"
              (click)="deleteClientAccess(client)"
            >
              <payee-icon
                width="18px"
                height="18px"
                [name]="'trash-red'"
              ></payee-icon>
            </button>
          </div>
        }
      </div>
      <button
        mat-button
        class="new-client-button"
        (click)="addClient()"
      >
        <div class="new-client-button-content flex vcenter hcenter">
          <payee-icon
            width="18px"
            height="18px"
            [name]="'plus-blue'"
          ></payee-icon>
          <span>{{ "CLIENT_ACCESS.ADD.BUTTON" | translate }}</span>
        </div>
      </button>
    </div>
  }
</div>
